(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Sezione', Sezione);

    Sezione.$inject = ['$resource'];

    function Sezione($resource) {
        
        var resourceUrl = 'api/:public/sezioni/:allNames'; // Modifica l'endpoint se necessario
        
        var resource = $resource(resourceUrl, {}, {
            'query': { 
                method: 'GET',
                params: {
                    public: 'public',
                    allNames: 'all-names'
                },
                isArray: true 
            }
        });

        return resource;
    }
})();
